/* AURA Studio RC3.2 — Hotspot Positioning Studio */
(() => {
  const isDesignMode = !!window.Shopify?.designMode || document.documentElement.classList.contains("shopify-design-mode");
  const debug = new URLSearchParams(location.search).get("aura_hotspots") === "1";
  if (!isDesignMode && !debug) return;

  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  const ensureStudio = (hero) => {
    if (!hero || hero.dataset.auraHotspotStudioReady === "true") return;
    hero.dataset.auraHotspotStudioReady = "true";

    const grid = document.createElement("div");
    grid.className = "aura-hotspot-studio-grid";
    hero.appendChild(grid);

    const panel = document.createElement("div");
    panel.className = "aura-hotspot-studio-panel";
    panel.innerHTML = `
      <h3>Hotspot Studio</h3>
      <p>Click or drag a hotspot. Copy the X/Y values into the block settings.</p>
      <div class="aura-hotspot-studio-panel__coords">
        <span>Device: <strong data-device>desktop</strong></span>
        <span>X: <strong data-x>—</strong>%</span>
        <span>Y: <strong data-y>—</strong>%</span>
      </div>
      <button type="button" data-copy>Copy coordinates</button>
    `;
    document.body.appendChild(panel);

    const toggle = document.createElement("button");
    toggle.className = "aura-hotspot-studio-toggle";
    toggle.type = "button";
    toggle.textContent = "Hotspot Studio";
    document.body.appendChild(toggle);

    let active = false;
    let selected = null;
    let last = { x: null, y: null };

    const setActive = (state) => {
      active = state;
      document.body.classList.toggle("aura-hotspot-studio-active", active);
      toggle.textContent = active ? "Close Studio" : "Hotspot Studio";
      hero.querySelectorAll(".aura-hotspot6").forEach(h => {
        h.dataset.auraHotspotDraggable = active ? "true" : "false";
      });
    };

    const updatePanel = (x, y) => {
      last = { x, y };
      panel.querySelector("[data-device]").textContent = isMobile() ? "mobile" : "desktop";
      panel.querySelector("[data-x]").textContent = x.toFixed(0);
      panel.querySelector("[data-y]").textContent = y.toFixed(0);
    };

    const setHotspot = (hotspot, x, y) => {
      if (!hotspot) return;
      if (isMobile()) {
        hotspot.style.setProperty("--hotspot-mobile-x", x + "%");
        hotspot.style.setProperty("--hotspot-mobile-y", y + "%");
      } else {
        hotspot.style.setProperty("--hotspot-x", x + "%");
        hotspot.style.setProperty("--hotspot-y", y + "%");
      }
      let badge = hotspot.querySelector(".aura-hotspot6__coords-badge");
      if (!badge) {
        badge = document.createElement("span");
        badge.className = "aura-hotspot6__coords-badge";
        hotspot.appendChild(badge);
      }
      badge.textContent = `${isMobile() ? "M" : "D"} X:${x.toFixed(0)} Y:${y.toFixed(0)}`;
      updatePanel(x, y);
    };

    const coords = (event) => {
      const rect = hero.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      return { x, y };
    };

    toggle.addEventListener("click", () => setActive(!active));

    hero.querySelectorAll(".aura-hotspot6").forEach((hotspot) => {
      const btn = hotspot.querySelector(".aura-hotspot6__button");
      if (!btn) return;

      btn.addEventListener("pointerdown", (event) => {
        if (!active) return;
        event.preventDefault();
        event.stopPropagation();
        selected = hotspot;
        hotspot.classList.add("is-dragging");
        hotspot.setPointerCapture?.(event.pointerId);
        const c = coords(event);
        setHotspot(hotspot, c.x, c.y);
      });

      btn.addEventListener("pointermove", (event) => {
        if (!active || selected !== hotspot) return;
        event.preventDefault();
        const c = coords(event);
        setHotspot(hotspot, c.x, c.y);
      });

      btn.addEventListener("pointerup", (event) => {
        if (!active) return;
        hotspot.classList.remove("is-dragging");
        selected = null;
      });
    });

    hero.addEventListener("click", (event) => {
      if (!active) return;
      const targetHotspot = event.target.closest(".aura-hotspot6");
      if (targetHotspot) return;
      const first = hero.querySelector(".aura-hotspot6");
      if (!first) return;
      const c = coords(event);
      setHotspot(first, c.x, c.y);
    });

    panel.querySelector("[data-copy]").addEventListener("click", async () => {
      const device = isMobile() ? "Mobile" : "Desktop";
      const txt = `${device} X: ${Math.round(last.x || 0)} | ${device} Y: ${Math.round(last.y || 0)}`;
      try {
        await navigator.clipboard.writeText(txt);
        panel.querySelector("[data-copy]").textContent = "Copied";
        setTimeout(() => panel.querySelector("[data-copy]").textContent = "Copy coordinates", 1200);
      } catch(e) {}
    });
  };

  const init = () => {
    document.querySelectorAll(".aura-hero-hotspots6, .aura-collection-hero4, [data-aura-collection-hero]").forEach(ensureStudio);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();

  document.addEventListener("shopify:section:load", init);
})();
